var routes = [
    {
        name: 'Consultas',
        icon: 'bi-card-list',
        route: '/',
    }
];

export default routes;
